/* eslint-disable @typescript-eslint/no-explicit-any */
export class CellChangedResponse {
  object!: any;

  column!: string;
}
